module.exports = __webpack_public_path__ + "static/media/saved_shipyard_marker.cfcde066.svg";